<div  #zoneConnectionsView (tunResize)="onResize($event)" class="main-container playerBackground">



  @if (connectNewZone) {
    <div
      #loginContainer
      class="login-container"
      >
      <tun-connect-zone-view
        class="connect-zone-view"
        (close)="onCloseConnectNew()"
        >
      </tun-connect-zone-view>
    </div>
  }

  <div
    #zoneConnectionsContainer
    class="zone-connections-container"
    >

    <div class="scrollContainer">

      <div
        class="fade-borders"
        [style.height.px]="(heightPerItem$ | async)"
        [style.padding-top.px]="2 * (heightPerItem$ | async)"
        >
        <tun-tunify-icon></tun-tunify-icon>
      </div>

      <div class="status fade-borders">
        @if ((zoneConnectionState$ | async) == ZoneConnectionsState.connectionError) {
          <label translate>zoneConnections.status.start.error</label>
          @if (!hasLostInternetAccessWhileShowingConnectionError) {
            <label translate>zoneConnections.status.start.general.error</label>
          }
          @if (hasLostInternetAccessWhileShowingConnectionError) {
            @if (!(hasInternetAccess$ | async)) {
              <label translate>zoneConnections.status.start.internet.error</label>
            }
            @if ((hasInternetAccess$ | async)) {
              <label translate>zoneConnections.status.start.internet.restored</label>
            }
          }
        }

        @if ((zoneConnectionState$ | async) == ZoneConnectionsState.disconnected) {
          <label translate>zoneConnections.status.loggedOut</label>
        }
        @if ((zoneConnectionState$ | async) == ZoneConnectionsState.creatingConnection) {
          <tun-loader text="connectZone.busy"></tun-loader>
        }
        @if ((zoneConnectionState$ | async) == ZoneConnectionsState.connecting) {
          <tun-loader text="login.busy"></tun-loader>
        }
      </div>

      @if ((focussedZoneError$ | async) != null) {
        <div class="errorFeedback fade-borders"
          >
          @if ((focussedZoneError$ | async) != null) {
            <label class="multiline" translate>{{focussedZoneError$ | async}}</label>
          }
          @if ((showBuySubscription$ | async)) {
            <button class="link-button" (click)="onBuyClick()" translate>
              settings.option.buy
            </button>
          }
        </div>
      }

      <div
        class="errorFeedback fade-borders"
        >
        @if ((externalApplicationInfo$ | async) != null) {
          <label translate>zoneConnections.inUse</label>
        }
        @if ((externalApplicationInfo$ | async) != null) {
          <label class="errorFeedbackColoredPart">{{(externalApplicationInfo$ | async).deviceInfo}}</label>
        }
      </div>

      <div class="flex-column">

        <div class="layerContainer zone-connections-layer-container">


          <div #scrollableZoneContainer class="layer scroll-container">



            @for (zoneConnection of zoneConnections$ | async; track zoneConnection; let i = $index) {
              <div
                class="zone-connection-view {{i == 0 ? 'first':''}} {{i == (zoneConnections$ | async).length -1 ? 'last':''}}">
                <tun-zone-connection-view
                  [zoneConnection]="zoneConnection"
                  >
                </tun-zone-connection-view>
              </div>
            }

          </div>


          @if ((zoneConnections$ | async).length > 1) {
            <div class="layer noPointer fade-borders">
              <div style="float: left;">
                <button
                  (click)="scrollLeft()"
                  class="button-transparent {{visibleZoneConnectionIndex > 0 ? '' : 'button-scroll-disabled'}}">
                  <fa-icon
                    class="button-item-icon"
                    size="lg"
                    [icon]="faAngleLeft"
                  ></fa-icon>
                </button>
              </div>
              <div style="float: right;">
                <button
                  (click)="scrollRight()"
                  class="button-transparent {{visibleZoneConnectionIndex < (zoneConnections$ | async).length - 1 ? '' : 'button-scroll-disabled'}}">
                  <fa-icon
                    class="button-item-icon"
                    size="lg"
                    [icon]="faAngleRight"
                  ></fa-icon>
                </button>
              </div>
            </div>
          }
        </div>


      </div>

      <div class="connect-new-container fade-borders">
        <button class="connect-button" [style.min-height.px]="1.5 * (heightPerItem$ | async)" (click)="connectNew()" translate>zoneConnections.connectNew</button>
      </div>

      <div class="flex-column fade-borders"></div>

      <div class="info-container fade-borders" translate>
        connectZone.info.contact
      </div>

    </div>
  </div>
</div>



